<template>
  <router-view />
</template>

<script>
export default {
  name: 'Rejected'
}
</script>

<style scoped>

</style>
